export const CONSTS = {
  EDIT: $localize`Edit`,
  DELETE: $localize`Delete`,
  DELETE_MODAL: {
    HEADER: $localize`Delete Message`,
    BODY: $localize`Are you sure you want to delete the message: \`%s\`?`,
    CONFIRM_BUTTON: $localize`Yes`,
    REJECT_BUTTON: $localize`No`,
  },
};
